module.exports = __webpack_public_path__ + "fonts/AkkRg_Pro_1.b96dbab.otf";